import type { FC, SVGProps } from "react";
import styles from "./Icon.module.css";

type ColorPreset =
  | "primary"
  | "secondary"
  | "error"
  | "success"
  | "warning"
  | "text"
  | "text-secondary"
  | "disabled";

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string | ColorPreset;
  variant?: "filled" | "outline";
  className?: string;
  viewBox?: string;
}

const colorMap: Record<ColorPreset, string> = {
  primary: "var(--pw-primary-color)",
  secondary: "var(--pw-secondary-color)",
  error: "var(--pw-error-color)",
  success: "var(--pw-success-color)",
  warning: "var(--pw-warning-color)",
  text: "var(--pw-text-color)",
  "text-secondary": "var(--pw-text-secondary)",
  disabled: "var(--pw-functional-disabled)",
};

export const Icon: FC<IconProps> = ({
  size = 24,
  color,
  variant = "filled",
  className,
  children,
  viewBox = "0 0 24 24",
  ...props
}) => {
  const resolvedColor =
    color && color in colorMap ? colorMap[color as ColorPreset] : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill={variant === "filled" ? "currentColor" : "none"}
      xmlns="http://www.w3.org/2000/svg"
      className={`${styles.icon} ${className || ""}`}
      style={{ color: resolvedColor }}
      {...props}
    >
      {children}
    </svg>
  );
};
